<template>
  <v-dialog :model-value="modelValue" @update:model-value="input" width="600">
    <v-card v-if="items">
      <v-table>
        <thead>
          <tr>
            <th class="text-left">
              {{
                $t(
                  "machines.location.dialogs.extraInfo.dataTable.headers.propertyCategory"
                )
              }}
            </th>
            <th class="text-left">
              {{
                $t(
                  "machines.location.dialogs.extraInfo.dataTable.headers.propertyName"
                )
              }}
            </th>
            <th class="text-left">
              {{
                $t(
                  "machines.location.dialogs.extraInfo.dataTable.headers.propertyValue"
                )
              }}
            </th>
          </tr>
        </thead>

        <tbody class="extra-info-dialog__body">
          <tr
            class="extra-info-dialog__row"
            v-for="(info, index) in items"
            :key="index"
          >
            <td>{{ info.category }}</td>
            <td>{{ info.name }}</td>
            <td>{{ info.value }}</td>
          </tr>
        </tbody>
      </v-table>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" color="primary" @click="input(false)">
          {{ $t("common.actions.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["items", "modelValue"],
  emits: ["update:modelValue"],
  methods: {
    input(open) {
      this.$emit("update:modelValue", open)
    }
  }
}
</script>

<style>
.extra-info-dialog__body .extra-info-dialog__row {
  cursor: default;
}
</style>
